export const getInitialState = ({
    localizationRegionPickerEnabled,
    memberCountryCodeIso2,
    isFunctionalCookiesEnabled,
    hasRegionPickerDismissedCookie,
    shippingCountryCookieValue,
    fallbackShippingCountry
}) => {
    const regionPickerDismissed =
        isFunctionalCookiesEnabled && hasRegionPickerDismissedCookie;
    const preferredShippingCountry = memberCountryCodeIso2
        ? memberCountryCodeIso2
        : isFunctionalCookiesEnabled &&
          !!shippingCountryCookieValue &&
          shippingCountryCookieValue;
    return {
        availableShippingCountries: [],
        isLoadingAvailableShippingCountries: false,
        hasLoadedAvailableShippingCountries: false,
        shippingCountry: {
            countryCodeIso2:
                preferredShippingCountry ||
                fallbackShippingCountry.toUpperCase()
        },
        localizationRegionPickerEnabled,
        regionPickerDismissed
    };
};
